import Breadcrumb from 'components/breadcrumb/Breadcrumb';
import FiltersBar from 'components/filters-bar/FiltersBar';
import ScenarioNavBar from 'components/scenario-bar/ScenarioNavBar';
import StatsBar from 'components/stats-bar/StatsBar';
import Topbar from 'components/topbar/Topbar';
import PropTypes from 'prop-types';
import { SCENARIO_LIST } from 'constants/components';
import {
    SCENARIO_FOUR_ROUTE,
    SCENARIO_ONE_ROUTE,
    SCENARIO_THREE_ROUTE,
    SCENARIO_TWO_ROUTE
} from 'constants/routes';
import { useEffect, useState, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { updateTimeslicerStartEndValues } from 'slices/FiltersSlice';
import { increaseEndDateByOneMonth } from 'utils/helpers';
import { selectDataIndex, selectSeriesIndex } from 'selectors/selectors';
import { resetScenarioOneCharts } from '../../slices/ScenarioOneSlice';

const Header = forwardRef(
    (
        {
            navigateHistory,
            navigateTo,
            navMenuItemHovered,
            setNavMenuItemHovered
        },
        ref
    ) => {
        const dispatch = useDispatch();
        const { pathname: route } = useLocation();
        const [isRibbonVisible, setRibbonVisible] = useState(() =>
            SCENARIO_LIST.map((s) => s.path).includes(route)
        );
        const dataIndex = useSelector(selectDataIndex);
        const seriesIndex = useSelector(selectSeriesIndex);

        useEffect(() => {
            if (
                [
                    SCENARIO_ONE_ROUTE,
                    SCENARIO_TWO_ROUTE,
                    SCENARIO_THREE_ROUTE,
                    SCENARIO_FOUR_ROUTE
                ].includes(route)
            ) {
                setRibbonVisible(() => true);
            } else setRibbonVisible(() => false);
        }, [route]);

        const onTimeSlicerChange = (startDate, endDate) => {
            dispatch(
                updateTimeslicerStartEndValues({
                    start: startDate,
                    end: increaseEndDateByOneMonth(endDate)
                })
            );
            // reset Scenario One Charts
            if (
                route === SCENARIO_ONE_ROUTE &&
                typeof seriesIndex === 'number' &&
                typeof dataIndex === 'number'
            ) {
                const eChartsInstance = ref.current.getEchartsInstance();
                eChartsInstance.dispatchAction({
                    type: 'unselect',
                    seriesIndex,
                    dataIndex
                });
            }
            dispatch(resetScenarioOneCharts());
        };

        const onFiltersChange = () => {
            // reset Scenario One Charts
            if (
                route === SCENARIO_ONE_ROUTE &&
                typeof seriesIndex === 'number' &&
                typeof dataIndex === 'number'
            ) {
                const eChartsInstance = ref.current.getEchartsInstance();
                eChartsInstance.dispatchAction({
                    type: 'unselect',
                    seriesIndex,
                    dataIndex
                });
            }
            dispatch(resetScenarioOneCharts());
        };

        return (
            <>
                <Topbar
                    navigateTo={navigateTo}
                    navMenuItemHovered={navMenuItemHovered}
                    setNavMenuItemHovered={setNavMenuItemHovered}
                    onFiltersChanged={onFiltersChange}
                />
                <Breadcrumb
                    navigateHistory={navigateHistory}
                    navigateTo={navigateTo}
                />
                <ScenarioNavBar
                    isRibbonVisible={isRibbonVisible}
                    navigateTo={navigateTo}
                />
                <FiltersBar
                    onTimeSlicerChange={onTimeSlicerChange}
                    ref={ref}
                    onFiltersChanged={onFiltersChange}
                />
                <StatsBar />
            </>
        );
    }
);

Header.displayName = 'Header';

Header.propTypes = {
    navigateHistory: PropTypes.array,
    navigateTo: PropTypes.func,
    navMenuItemHovered: PropTypes.number,
    setNavMenuItemHovered: PropTypes.func
};
export default Header;
